import type { PropsWithChildren, ReactElement } from "react";
import { ImageSizesContext } from "./Image.js";

interface ModalScreenshotProps {
  size?: "sm" | "md" | "lg";
}

/**
 * The modal frame caps its image at ~520px on desktop and ~90vw on small
 * screens. Declaring that here lets nested images fetch a right-sized variant
 * instead of the full-width default.
 */
const MODAL_IMAGE_SIZES = "(min-width: 768px) 520px, 90vw";

const marginClasses = {
  sm: "mx-32",
  md: "mx-16",
  lg: "mx-8",
};

export function ModalScreenshot({
  children,
  size,
}: PropsWithChildren<ModalScreenshotProps>): ReactElement {
  const marginClass = size ? (marginClasses[size] ?? "mx-auto") : "mx-auto";

  return (
    <div
      className={`[&>p]:m-0 [&>p]:p-0 [&>p>img]:m-0 [&>p>img]:p-0 my-8 ${marginClass}`}
    >
      <div className="relative block w-fit rounded-lg overflow-hidden shadow-2xl mx-auto max-w-[90%] [&_img]:!border-0 [&_img]:!rounded-none [&_img]:!p-0 [&_img]:!m-0 [&_img]:!block [&_img]:!max-w-full [&_img]:!h-auto [&_p]:!m-0 [&_p]:!p-0 [&_p]:!leading-[0]">
        <div className="absolute inset-0 backdrop-blur-lg pointer-events-none bg-black/30 dark:bg-white/20" />
        <div className="relative p-4 block">
          <div className="relative rounded-lg overflow-hidden shadow-lg border border-border">
            <ImageSizesContext.Provider value={MODAL_IMAGE_SIZES}>
              {children}
            </ImageSizesContext.Provider>
          </div>
        </div>
      </div>
    </div>
  );
}
